import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();
  const { pathname, hash } = location;
  const navigationType = useNavigationType();
  const restoreHomeScroll = location.state?.restoreHomeScroll === true;
  const hasBackgroundLocation = Boolean(location.state?.backgroundLocation);

  useEffect(() => {
    if (hasBackgroundLocation) {
      return;
    }

    const hasPendingHomeRestore =
      pathname === '/' &&
      (restoreHomeScroll || sessionStorage.getItem('homeScrollRestore') === '1');
    // Only scroll to top if there's no hash and it's not a "back/forward" navigation
    if (!hash && navigationType !== 'POP' && !hasPendingHomeRestore) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, navigationType, restoreHomeScroll, hasBackgroundLocation]);

  return null;
};

export default ScrollToTop;
